module.exports = __webpack_public_path__ + "img/202502_09.dbf6686c.jpg";